import { Alert, Badge } from 'react-bootstrap'
import { useQuery } from 'react-query'

import api from '../../services/api'
import { calcularAviso } from '../../utils/avisoTimbres'

/**
 * Lo que le queda de timbres al contador, donde factura.
 *
 * Sin esto se enteraría de que se quedó sin timbres **al ser rechazado al timbrar**. El
 * requerimiento pide avisar en 20, 10 y 5, y bloquear en 0: avisar sólo al final es no avisar.
 *
 * No se muestra nada cuando no hay nada que decir --saldo holgado, o un contador con licencia
 * interna, que no consume de una bolsa vendida--: una barra permanente deja de leerse.
 */
export default function AlertaTimbres() {
  const { data } = useQuery(
    'mi-licencia',
    async () => (await api.get('/auth/mi-licencia/')).data,
    {
      // El saldo cambia al timbrar, así que se refresca al volver a la pantalla.
      refetchOnWindowFocus: true,
      // Un fallo aquí no debe estorbar la facturación: la query queda sin datos y no se
      // dibuja nada.
      retry: false,
    }
  )

  const aviso = calcularAviso(data)
  if (!aviso) return null

  return (
    <Alert variant={aviso.variante}
           className="d-flex justify-content-between align-items-center py-2">
      <div className="d-flex align-items-center gap-2">
        <i className={`bi ${aviso.esBloqueo ? 'bi-x-octagon' : 'bi-exclamation-triangle'}`}></i>
        <span>{aviso.texto}</span>
      </div>
      {aviso.contador && <Badge bg={aviso.variante}>{aviso.contador}</Badge>}
    </Alert>
  )
}
